// extracted by mini-css-extract-plugin
export default {"completeProfileForm":"Forms_completeProfileForm__Gmwqx","completeProfileBg":"Forms_completeProfileBg__KT-37"};